import React from 'react';

import {CircularProgress} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import ChecklistOptionCreate from "./ChecklistOptionCreate";


class ChecklistOptionList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checklistOptions: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveChecklistOptions();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveChecklistOptions();
        }
    }

    async retrieveChecklistOptions() {
        const url = 'checklist_option/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                checklistOptions: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.checklistOptions) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <CommonPaginatedTable
                title={'Варианты ответов чек-листов'}
                url={'admin/checklist_option'}
                callBack={this.retrieveChecklistOptions.bind(this)}
                extraComponents={[
                    {
                        component: ChecklistOptionCreate,
                        componentProps: {}
                    }
                ]}
                data={this.state.checklistOptions}
                pages={this.state.pages}
                pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                fields={[
                    {
                        title: 'Название',
                        name: 'title',
                        visible: true,
                        edit: {
                            permission: true,
                            fields: ['title', ],
                            baseUrl: 'checklist_option',
                            callBack: this.retrieveChecklistOptions.bind(this),
                        },
                    },
                    {
                        title: 'Метка',
                        name: 'label',
                        visible: true,
                        edit: {
                            permission: true,
                            fields: ['label', ],
                            baseUrl: 'checklist_option',
                            callBack: this.retrieveChecklistOptions.bind(this),
                        },
                    },
                    {
                        title: 'Создано',
                        name: 'created_on',
                        visible: true,
                    },
                    {
                        title: 'Обновлено',
                        name: 'updated_on',
                        visible: true,
                    },
                ]
                }
            />
        )
    }
}

export default withRouter(ChecklistOptionList)